import React, { useState } from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import axios from "axios";

const ContactForm = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  console.log("Base URL:", baseUrl);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false); 

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); 

    try {
      const response = await axios.post(`${baseUrl}/send-email`, formData);
      alert(response.data.message);
      setFormData({ name: "", email: "", phone: "", message: "" });
    } catch (error) {
      alert(
        error.response?.data?.message || "Error sending email. Try again."
      );
      console.error("Email Error:", error);
    } finally {
      setLoading(false); 
    }
  };

  return (
    <div className="mt-5 mb-5 contact-form-section pt-5">
      <h2 className="about-title pt-5 mt-3 text-center">
        Contact Us
      </h2>
      <p className="text-center pt-3">
        Have questions? Fill out the form, and we'll get back to you!
      </p>

      <Container>
        <Row className="justify-content-center">
          <Col
            md={6}
            style={{
              background: "#f8f9fa",
              padding: "30px",
              borderRadius: "10px",
              boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
            }}
          >
            <Form onSubmit={handleSubmit}>
              {/* Name Field */}
              <Form.Group className="mb-3">
                <Form.Label style={{ fontWeight: "bold" }}>Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Enter your name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={{
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    padding: "10px",
                  }}
                />
              </Form.Group>

              {/* Email Field */}
              <Form.Group className="mb-3">
                <Form.Label style={{ fontWeight: "bold" }}>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  style={{
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    padding: "10px",
                  }}
                />
              </Form.Group>

              {/* Phone Field */}
              <Form.Group className="mb-3">
                <Form.Label style={{ fontWeight: "bold" }}>Phone</Form.Label>
                <Form.Control
                  type="tel"
                  name="phone"
                  placeholder="Enter your phone number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  style={{
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    padding: "10px",
                  }}
                />
              </Form.Group>

              {/* Message Field */}
              <Form.Group className="mb-3">
                <Form.Label style={{ fontWeight: "bold" }}>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="message"
                  placeholder="Enter your message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  style={{
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    padding: "10px",
                    resize: "vertical",
                  }}
                />
              </Form.Group>

              {/* Submit Button */}
              <Button
                variant="primary"
                type="submit"
                className="w-100"
                disabled={loading} 
                style={{
                  padding: "10px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  borderRadius: "5px",
                }}
              >
                {loading ? "Submitting..." : "Submit"} 
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContactForm;
